import styled from 'styled-components';
import Loader from 'calcite-react/Loader';

const StyledSidebar = styled.div`
  height: 85%;
  width: 100%;
`;

const StyledTab = styled.div`
  color: ${({ theme }) => theme.palette.primary.main};
  font-family: 'Montserrat';
  font-weight: 700;
  width: 100%;
  height: 10%;
  background-color: #F3F3F3;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const StyledLoader = styled(Loader)`
  margin-top: 4rem;
`;

export { StyledSidebar, StyledTab, StyledLoader };
